import { render } from "./SocialOfferInfo.vue?vue&type=template&id=3f58d4db&scoped=true"
import script from "./SocialOfferInfo.vue?vue&type=script&lang=js"
export * from "./SocialOfferInfo.vue?vue&type=script&lang=js"

import "./SocialOfferInfo.vue?vue&type=style&index=0&id=3f58d4db&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f58d4db"],['__file',"webpack-assets/vue/templates/product/catalog/parts/SocialOfferInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f58d4db"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f58d4db', __exports__)) {
    api.reload('3f58d4db', __exports__)
  }
  
  module.hot.accept("./SocialOfferInfo.vue?vue&type=template&id=3f58d4db&scoped=true", () => {
    api.rerender('3f58d4db', render)
  })

}


export default __exports__